<template>
  <div class="cert-header d-flex py-5">
    <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
      <div class="cert-title cert-large">Legal and Regulatory</div>
    </div>
  </div>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
    <div v-for="(item,index) in items" :key="index" :ref="`i${index}`">
      <cert-law-container :title="item.title"
                          :description="item.description"
                          :url="item.url"
                          :separator="index!==items.length-1"
                          :pre-download="item.preDownload"/>
    </div>
  </div>
</template>

<script>
import CertLawContainer from "./components/CertLawContainer"

export default {
  name: "Legal",
  components: {
    CertLawContainer,
  },
  data() {
    return {
      items: [
        {
          title: "Law on Prevention and Punishment of Cyber Crimes",
          description: "Law Nº 60/2018 of 22/8/2018 on prevention and punishment of cyber crimes",
          url: `${process.env.VUE_APP_BASE_URL}file/law_on_prevention_and_punishment_of_cyber_crimes.pdf`,
          preDownload: true
        },
        {
          title: "Law Governing Information and Communication Technologies in Rwanda",
          description: "Law N°24/2016 of 18/06/2016 governing information and communication technologies",
          url: `${process.env.VUE_APP_BASE_URL}file/law_governing_information_and_communication_technologies_in_rwanda.pdf`,
          preDownload: true
        },
        {
          title: "Law Regulating Media",
          description: "Law N°02/2013 of 08/02/2013 regulating media",
          url: `${process.env.VUE_APP_BASE_URL}file/law_media.pdf`,
          preDownload: true
        },
        {
          title: "Law on the Protection of Intellectual Property",
          description: "Law N° 31/2009 of 26/10/2009 on the protection of intellectual property",
          url: `${process.env.VUE_APP_BASE_URL}file/law_on_intellectual_property.pdf`,
          preDownload: true
        },
        {
          title: "Rwanda Child Online Protection Policy",
          description: "Rwanda Child Online Protection Policy",
          url: `${process.env.VUE_APP_BASE_URL}file/rwanda_child_online_protection_policy.pdf`,
          preDownload: true
        },
        {
          title: "Regulation Governing Cyber Security",
          description: "Regulation N° 010/R/CR-CSI/RURA/020 of 29/05/2020 governing cyber security",
          url: `${process.env.VUE_APP_BASE_URL}file/regulation_governing_cybersecurity.pdf`,
          preDownload: true
        },
        {
          title: "New Regulation on Cyber Security",
          description: "Regulation N° 02/2018 of 24/01/2018 on cyber security",
          url: `${process.env.VUE_APP_BASE_URL}file/new_regulation_on_cybersecurity.pdf`,
          preDownload: true
        },
      ],
    };
  },
  mounted() {
    this.$anim.fadeInBottomOpaque(this.$refs["content"], 50);
    for (let i = 0; i < this.items.length; i++)
      this.$anim.fadeInBottom(this.$refs[`i${i}`], 50 * i);
  }
}
</script>